import { render, staticRenderFns } from "./WizardGDPR.vue?vue&type=template&id=74bb69a0&"
import script from "./WizardGDPR.vue?vue&type=script&lang=js&"
export * from "./WizardGDPR.vue?vue&type=script&lang=js&"
import style0 from "./WizardGDPR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports